import { ContentRequest, ContentRequestState } from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import Breadcrumbs from '../common/Breadcrumbs';
import LoadingPage from '../common/LoadingPage';
import ContentRequestDetails from './ContentRequestDetails';
import { convertEntities } from '@amzn/awscat-editor';
import AppContextProps from '../../contexts/AppContextProps';
import { withAppContext } from '../../contexts/AppContext';

interface ContentRequestViewerProps
  extends AppContextProps, RouteComponentProps<{ requestId: string }> {}

const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

const ContentRequestViewer = (props: ContentRequestViewerProps) => {
  const [isLoadingContentRequest, setIsLoading] = useState<boolean>(true);
  const [contentRequest, setContentRequest] = useState<ContentRequest | null>(null);

  useEffect(() => {
    const fetchContentRequest = async () => {
      const contentRequestResponse = await mplServiceClient.getContentRequestById(
        props.match.params.requestId,
      );
      setContentRequest(contentRequestResponse.contentRequest);
      setIsLoading(false);
    };

    fetchContentRequest();
  }, [props.match.params.requestId]);

  const updateContentRequest = async (
    contentRequestId: string,
    state: ContentRequestState,
    assigneeId?: string,
  ) => {
    const updatedContentRequestResponse = await mplServiceClient.updateContentRequests(
      contentRequestId,
      state,
      { assigneeId },
    );
    setContentRequest(updatedContentRequestResponse.contentRequest);
  };

  if (isLoadingContentRequest || !contentRequest) {
    return <LoadingPage />;
  }

  const breadcrumbItems = [
    { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
    {
      text: convertEntities(
        contentRequest.contentRequestData.contentName,
        props.appContext.entities,
      ),
      href: '',
    },
  ];
  return (
    <div className="content-request-viewer-container">
      <Breadcrumbs items={breadcrumbItems} />
      <ContentRequestDetails
        updateContentRequest={updateContentRequest}
        contentRequest={contentRequest}
      />
    </div>
  );
};

export default withRouter(withAppContext(ContentRequestViewer));
